import { render, staticRenderFns } from "./tab_product_detail.vue?vue&type=template&id=c6e29700&scoped=true"
import script from "./tab_product_detail.vue?vue&type=script&lang=js"
export * from "./tab_product_detail.vue?vue&type=script&lang=js"
import style0 from "./tab_product_detail.vue?vue&type=style&index=0&id=c6e29700&prod&lang=css"
import style1 from "./tab_product_detail.vue?vue&type=style&index=1&id=c6e29700&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e29700",
  null
  
)

export default component.exports